import React from "react"
import Layout from "./src/components/_Layout"
import "./src/styles/main.css"

const transitionDelay = 0

export const onInitialClientRender = () => {
  const wrapper = document.getElementById('gatsby-focus-wrapper');
  if (wrapper) wrapper.style = undefined;
};

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      transitionDelay
    )
  }
  return false
}
